import './action-bar.scss';

class ActionBar {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-actionbar',
            copyAttr: 'data-actionbar-copy',
            hideAttr: 'data-actionbar-hide',
            stickyAttr: 'data-actionbar-sticky'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$actionBar = $element;
        this.$actionBarWrapper = this.$actionBar.parentNode;
        this.$$shareButtons = this.$actionBar.querySelectorAll(`[${this.settings.initAttr}="share-button"]`);
        this.$$hiddenSections = document.querySelectorAll(`[${this.settings.hideAttr}]`);
        this.$shareItem = this.$actionBar.querySelector(`[${this.settings.initAttr}="item"]`);
        this.$shareList = this.$actionBar.querySelector(`[${this.settings.initAttr}="share-list"]`);
        this.$closeButton = this.$actionBar.querySelector(`[${this.settings.initAttr}="close"]`);
        this.$copyButton = this.$actionBar.querySelector(`[${this.settings.copyAttr}]`);
        this.$copySuccess = this.$actionBar.querySelector(`[${this.settings.initAttr}="copied"]`);

        this.open = false;
        this.visible = false;
        this.inital = true;
        this.isSticky = null;

        this.initialize();
    }

    initialize () {
        if (this.$actionBar.hasAttribute(`${this.settings.stickyAttr}`)) {
            this.isSticky = true;
            this.toggleBar();
        } else {
            this.isSticky = false;
        }

        this.setEvents();
    }

    // Update usercentrics icon position
    updateUsercentrics () {
        const $usercentrics = document.getElementById('usercentrics-root');

        if ($usercentrics) {
            const $shadowRoot = $usercentrics.shadowRoot;
            const $styleTag = $shadowRoot.querySelector('[custom-style]');
            let space;

            if (this.visible) {
                space = this.$actionBar.offsetHeight;
            } else {
                space = 0;
            }

            const styleInformation = `\n button[data-testid] { transform: translateY(-${space}px); transition: transform 0.3s cubic-bezier(0.25, 1, 0.5, 1)`;

            if (!$styleTag) {
                const $styleTag = document.createElement('style');
                $styleTag.setAttribute('custom-style', '');
                $styleTag.innerHTML = styleInformation;
                $shadowRoot.appendChild($styleTag);
            } else {
                $styleTag.innerHTML = styleInformation;
            }
        }
    }

    // Add url to users clipboard
    addToClipboard (target) {
        const url = target.getAttribute(this.settings.copyAttr);

        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
            target.classList.add('is--hidden');
            this.$copySuccess.classList.remove('is--hidden');

            // Reset after 3 seconds
            setTimeout(() => {
                target.classList.remove('is--hidden');
                this.$copySuccess.classList.add('is--hidden');
            }, 3000);

            return navigator.clipboard.writeText(url);
        }
    }

    // Toggle action bar visibility
    toggleBar () {
        if (this.isSticky) {
            const isInview = window.eventScroller.onScreen(this.$actionBar);
            const position = this.$actionBarWrapper.getBoundingClientRect().bottom;
            const windowHeight = window.innerHeight;
            let visible = false;

            if (isInview && position >= windowHeight - 1) {
                visible = true;
            } else {
                visible = false;
            }

            if (visible !== this.visible) {
                this.visible = visible;
                this.updateUsercentrics();
            }
        }
    }

    openOverlay () {
        this.$shareList.classList.remove('is--hidden');
        this.$shareItem.classList.add('is--hidden');
        this.open = true;
    }

    closeOverlay () {
        this.$shareList.classList.add('is--hidden');
        this.$shareItem.classList.remove('is--hidden');
        this.open = false;
    }

    setEvents () {
        // Open overlay
        if (this.$$shareButtons.length !== 0) {
            for (let index = 0; index < this.$$shareButtons.length; index++) {
                this.$$shareButtons[index].addEventListener('click', () => {
                    this.openOverlay();
                    this.updateUsercentrics();
                });
            }
        }

        // Close overlay
        if (this.$closeButton) {
            this.$closeButton.addEventListener('click', () => {
                this.closeOverlay();
                this.updateUsercentrics();
            });
        }

        // Copy link to clipboard
        if (this.$copyButton) {
            this.$copyButton.addEventListener('click', (e) => {
                this.addToClipboard(e.target);
            });
        }

        // fire togglebar handling on scroll
        window.eventScroller.customFunctions.push(() => {
            this.toggleBar();
        });
    }
}

export { ActionBar };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$ActionBar = $context.querySelectorAll('[data-actionbar="root"]');
        for (let i = 0; i < $$ActionBar.length; i++) {
            const $ActionBar = $$ActionBar[i];

            const ActionBarAPI = new ActionBar($ActionBar);
            $ActionBar.API = ActionBarAPI;
        }
    }
});
